import React from 'react';
import logo from '../../../images/logo.png';
import './index.less';

export default () => (
  <div className="slide1 slide">
    <img className="slide1-logo" src={logo} alt="" />
  </div>
);
